// eslint-disable-next-line no-sparse-arrays
export let jsonCafe = [
  {
    name: "Espresso",
    detail: "JARRITO",
    price: "500",
    section: "Cafe",
  },
  {
    name: "Espresso mediano",
    detail: "",
    price: "600",
    section: "Cafe",
  },
  ,
  {
    name: "Cafe con leche",
    detail: "",
    price: "750",
    section: "Cafe",
  },

  {
    name: "Frapuchino",

    detail: "",
    price: "950",
    section: "Cafe",
  },
  {
    name: "Capuccino",

    detail: "",
    price: "850",
    section: "Cafe",
  },
  {
    name: "Submarino ",

    detail: "Dosis de leche espumada a 90° con barra de chocolate amargo ",
    price: "850",
    section: "Cafe",
  },
  {
    name: "Té",

    detail: "› Consultar por opciones",
    price: "450",
    section: "Cafe",
  }
  ,
  {
    name: "Medialuna",

    detail: "›Dulce o Salada",
    price: "200",
    section: "Desayuno/Merienda",
  },
  {
    name: "Medialuna con jamon y queso",

    detail: "›",
    price: "300",
    section: "Desayuno/Merienda",
  }
  ,
  {
    name: "Tostadas x4",

    detail: "› Pan comun o integral - vienen con manteca y mermelada ",
    price: "900",
    section: "Desayuno/Merienda",
  }
  ,
  {
    name: "Brusquetas de palta",

    detail: "› Huevo, panceta y queso crema",
    price: "800",
    section: "Desayuno/Merienda",
  }
  ,
  {
    name: "Brusqueta capresse",

    detail: "›",
    price: "700",
    section: "Desayuno/Merienda",
  }
  ,
  {
    name: "Tostado Primavera",

    detail: "›",
    price: "1600",
    section: "Desayuno/Merienda"
  }
 
  ,
  {
    name: "Tostado jamon y queso",

    detail: "›",
    price: "1300",
    section: "TAPEOS",
  }
  ,
  {
    name: "Tostado Primavera",

    detail: "›",
    price: "1600",
    section: "TAPEOS"
  }
  ,
  {
    name: "Yogurt con granola y frutas de estacion",

    detail: "›",
    price: "750",
    section: "Desayuno/Merienda",
  }
  ,
  {
    name: "Tarta de coco",

    detail: "› Porcion",
    price: "750",
    section: "DELICATESSEN",
  }
  ,
  {
    name: "Torta Cabsha",

    detail: "›Porcion",
    price: "750",
    section: "DELICATESSEN",
  }
  ,
  {
    name: "Crumblee de manzana",

    detail: "›Porcion",
    price: "800",
    section: "DELICATESSEN",
  }
  ,
  {
    name: "Flan casero",

    detail: "›",
    price: "900",
    section: "POSTRES",
  }
  ,
  {
    name: "Bochas de helado",

    detail: "›",
    price: "900",
    section: "POSTRES",
  }
  ,
  {
    name: "Frutillas con crema",

    detail: "›",
    price: "1200",
    section: "POSTRES",
  }
  ,
  {
    name: "Ensalada de frutas con Helado de americana",

    detail: "›",
    price: "1100",
    section: "POSTRES",
  }
  ,
  {
    name: "Chocotorta",

    detail: "›",
    price: "900",
    section: "POSTRES",
  }
  ,
  {
    name: "Papas fritas",

    detail: "› ",
    price: "1100",
    section: "TAPEOS",
  },
  {
    name: "Papas gratinadas ",

    detail: "› ",
    price: "1300",
    section: "TAPEOS",
  }
  ,
  {
    name: "Langostinos rebozados",

    detail: "›",
    price: "3200",
    section: "TAPEOS",
  }
  ,
  {
    name: "Provoleta",

    detail: "› Queso provolone fundido con pesto y tomates cherry",
    price: "1100",
    section: "TAPEOS",
  },
 
  {
    name: "Tapero para compartir ",
    detail: "› Rabas, Bastoncitos de Muzza, Aros de cebolla, Pollo Crispy",
    price: "5200",
    section: "TAPEOS",
  },
  {
    name: "Rabas",

    detail: "› CON LIMÓN Y ALIOLI",
    price: "3100",
    section: "TAPEOS",
  },
  {
    name: "Bastoncitos de muzzarella",

    detail: "› ",
    price: "2100",
    section: "TAPEOS",
  },
  {
    name: "Tostados",

    detail: "",
    price: "1000",
    section: "TAPEOS",
  },
  {
    name: "Avocado toast",

    detail: "",
    price: "900",
    section: "TAPEOS",
  },
  {
    name: "Aros de cebolla",

    detail: "",
    price: "1400",
    section: "TAPEOS",
  },
  {
    name: "Pollo crispy",

    detail: "",
    price: "1900",
    section: "TAPEOS",
  },

  {
    name: "Lomito jyq",

    detail:"›sale con fritas o ensalada: mixta",
    price: "2100",
    section: "PLATOS PRINCIPALES",
  },
  {
    name: "Lomito completo ",

    detail:"›sale con fritas o ensalada: mixta - Jamon, queso, lechuga, tomate ",
    price: "2400",
    section: "PLATOS PRINCIPALES",
  },
  {
    name: "Milanesa de terneta jyq",

    detail: "›sale con fritas o ensalada: mixta ",
    price: "2000",
    section: "PLATOS PRINCIPALES",
  },
  {
    name: "Milanesa de ternera completa ",

    detail: "›sale con fritas o ensalada: mixta ",
    price: "2300",
    section: "PLATOS PRINCIPALES",
  },
  {
    name: "Milanesa de ternersa napolitana",

    detail: "›sale con fritas o ensalada: mixta",
    price: "2700",
    section: "PLATOS PRINCIPALES",
  },
  {
    name: "Milanesa de pollo jyq",
    //  photo:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0tyjpNmH6AQFzybK3XbWBX4fkw6E-E4GwJDd7a8SujC1C0xrbhmU3j8n9L8eM31qmAo0&usqp=CAU",
    detail: "›sale con fritas o ensalada: mixta",
    price: "2100",
    section: "PLATOS PRINCIPALES",
  },
  {
    name: "Milanesa de pollo completa",
    detail: "›sale con fritas o ensalada: mixta",
    price: "2100",
    section: "PLATOS PRINCIPALES",
  },
  {
    name: "Milanesa de pollo  napolitana",

    detail: "›sale con fritas o ensalada: mixta",
    price: "2400",
    section: "PLATOS PRINCIPALES",
  }
 ,
  {
    name: "Pechuga grillada a las finas hierbas: ",
    //  photo:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0tyjpNmH6AQFzybK3XbWBX4fkw6E-E4GwJDd7a8SujC1C0xrbhmU3j8n9L8eM31qmAo0&usqp=CAU",
    detail: "›sale con fritas o ensalada: mixta",
    price: "2300",
    section: "PLATOS PRINCIPALES",
  }
  ,
  {
    name: "Wok de vegetales ",
    //  photo:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0tyjpNmH6AQFzybK3XbWBX4fkw6E-E4GwJDd7a8SujC1C0xrbhmU3j8n9L8eM31qmAo0&usqp=CAU",
    detail: "›Verdeo, Zanahoria, Morron, Berenjena, Zucchini, Repollo, Arroz, Soja y Aceite de Sesamo",
    price: "2100",
    section: "PLATOS PRINCIPALES",
  }
  ,
  {
    name: "Wok de pollo ",
    //  photo:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0tyjpNmH6AQFzybK3XbWBX4fkw6E-E4GwJDd7a8SujC1C0xrbhmU3j8n9L8eM31qmAo0&usqp=CAU",
    detail: "›Ajo, Verdeo, Zanahoria, Morron, Berenjena, Zucchini, Champis, jengibre, Pollo y Salsa Teriyaki",
    price: "2400",
    section: "PLATOS PRINCIPALES",
  }
  ,
  {
    name: "Wok de lomo",
    //  photo:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0tyjpNmH6AQFzybK3XbWBX4fkw6E-E4GwJDd7a8SujC1C0xrbhmU3j8n9L8eM31qmAo0&usqp=CAU",
    detail: "›Ajo, cebolla Morada, Zanahoria, Morron, Berenjena, Zucchini, Lonjas de Lomo, Soja y Mostaza Dijon",
    price: "2700",
    section: "PLATOS PRINCIPALES",
  }
  ,
  {
    name: "Lomito jyq",
    detail: "Sale con fritas o mixtaSale con fritas o mixta",
    price: "2500",
    section: "SANDWICH",
  },
  {
    name: "Lomito completo",
    detail: "sale con fritas o ensalada: mixta - Jamon, queso, lechuga, tomate",
    price: "2800",
    section: "SANDWICH",
  },
  {
    name: "Hamburguesa jyq",
    detail: "Sale con fritas o mixta",
    price: "1900",
    section: "SANDWICH",
  },
  {
    name: "Hamburguesa completa",
    detail: "Sale con fritas o mixta",
    price: "2100",
    section: "SANDWICH",
  },

  {
    name: "Milanesa de ternera jyq",
    detail: "Sale con fritas o mixta",
    price: "2300",
    section: "SANDWICH",
  },
  {
    name: "Milanesa de ternera completa ",
    detail: "Sale con fritas o mixta",
    price: "2700",
    section: "SANDWICH",
  },
  {
    name: "Milanesa de pollo jyq",
    detail: "Sale con fritas o mixta",
    price: "2100",
    section: "SANDWICH",
  },
  {
    name: "Milanesa de pollo completa ",
    detail: "Sale con fritas o mixta",
    price: "2500",
    section: "SANDWICH",
  },
  {
    name: "Hamburguesa veggie en pan de remolacha ",
    detail: "Medallon de Lentejas con rucula, tomate y mayo de zanahoria - Sale con fritas o mixta",
    price: "2100",
    section: "SANDWICH",
  },
  {
    name: "Chori a la planchetta ",
    detail: "Chori puro cerdo, con jamón, queso, rúcula y chimi. Acompañado con dip de salsa criolla.",
    price: "1800",
    section: "SANDWICH",
  },
  {
    name: "Adicional huevo frito ",
    detail: "",
    price: "600",
    section: "SANDWICH",
  },

  {
    name: "Chori a la plancha ",
    detail: "Chori puro cerdo, con jamón, queso, rúcula y chimi. Acompañado con dip de salsa criolla. ",
    price: "1800",
    section: "SANDWICH",
  }
  ,
  {
    name: "Vacío tiernizado  ",
    detail: "Con muzarela, tomate, Mayo de albahaca",
    price: "2600",
    section: "SANDWICH",
  },
  {
    name: "Diosa verde",
    detail: "Mix verde, cebolla morada, palta, manzana verde y tomate cherry",
    price: "1600",
    section: "ENSALSADAS",
  },
  {
    name: "Mixta",
    detail: "Lechuga tomate y cebollla",
    price: "1300",
    section: "ENSALSADAS",
  },
  {
    name: "Caesar",
    detail: "Lechuga, pollo, crutones, sardo y salsa caesar",
    price: "2200",
    section: "ENSALSADAS",
  },
  {
    name: "Palta",
    detail: "Arroz, palta, tomate y queso",
    price: "20400",
    section: "ENSALSADAS",
  }
  ,
  {
    name: "Fresca",
    detail: "Repollo, Lechuga,Tomate, Zanahoria, Choclo y Hebras de Queso ",
    price: "2200",
    section: "ENSALSADAS",
  }
  ,

  {
    name: "SALSA ALIOLI-CAESAR-TARTARA",
    detail: "Ideal para acompañar y levantar el sabor de cualquier plato, sandwich o ensalada",
    price: "500",
    section: "DIPS DE SALSAS",
  }
  ,
  {
    name: "MAYONESA DE ZANAHORIA-ALBAHACA-CIBOULETTE",
    detail: "Ideal para acompañar y levantar el sabor de cualquier plato, sandwich o ensalada",
    price: "500",
    section: "DIPS DE SALSAS",
  }
  ,
  {
    name: "MEDITERRANEA Tomate, ajo, verdeo, pepino y limon",
    detail: "Tomate, ajo, verdeo, pepino y limon - Ideal para acompañar y levantar el sabor de cualquier plato, sandwich o ensalada",
    price: "500",
    section: "DIPS DE SALSAS",
  }
  ,
  {
    name: "Jalapeños Picante",
    detail: "Tomate, ajo, verdeo, pepino y limon - Ideal para acompañar y levantar el sabor de cualquier plato, sandwich o ensalada",
    price: "500",
    section: "DIPS DE SALSAS",
  },
  {
    name: "Muzarella",
    detail: "4 porciones",
    price: "1400",
    section: "PIZZAS",
  },
  {
    name: "Americana",
    detail: "Con panceta y huevo - 4 porciones",
    price: "2000",
    section: "PIZZAS",
  },
  {
    name: "Especial",
    detail: "4 porciones",
    price: "1600",
    section: "PIZZAS",
  },
  {
    name: "Napolitana",
    detail: "4 porciones",
    price: "1600",
    section: "PIZZAS",
  },
  {
    name: "Capresse",
    detail: "4 porciones",
    price: "1500",
    section: "PIZZAS",
  },
  {
    name: "4 quesos",
    detail: "Muzza, sardo, roquefort y provolone - 4 porciones",
    price: "1800",
    section: "PIZZAS",
  },
  {
    name: "Roquefort apio y nuez",
    detail: "4 porciones",
    price: "2000",
    section: "PIZZAS",
  },
  {
    name: "Rucula, crudo, sardo y tomates secos",
    detail: "4 porciones",
    price: "2200",
    section: "PIZZAS",
  }
 ,
  {
    name: "Agua 500cc ",
    detail: "",
    price: "400",
    section: "SIN ALCOHOL",
  },
  {
    name: "Agua 1,5lts",
    detail: "",
    price: "800",
    section: "SIN ALCOHOL",
  },
  {
    name: "Agua saborizada 500cc",
    detail: "",
    price: "500",
    section: "SIN ALCOHOL",
  },
  {
    name: "Agua saborizada 1,5lts ",
    detail: "",
    price: "1200",
    section: "SIN ALCOHOL",
  },
  {
    name: "Gaseosa 500cc",
    detail: "Linea PEPSI",
    price: "500",
    section: "SIN ALCOHOL",
  },
  {
    name: "Gaseosa 1,5lts",
    detail: "Linea PEPSI",
    price: "1300",
    section: "SIN ALCOHOL",
  }
  ,
  {
    name: "Energozante",
    detail: "RED BULL",
    price: "700",
    section: "SIN ALCOHOL",
  },
  {
    name: "Limonada",
    detail: "Con menta y jengibre",
    price: "700",
    section: "JUGOS & LICUADOS",
  }
  ,
  {
    name: "Jarra Limonada",
    detail: "Con menta y jengibre",
    price: "1200",
    section: "JUGOS & LICUADOS",
  },
  {
    name: "Pomelada",
    detail: "",
    price: "700",
    section: "JUGOS & LICUADOS",
  }
  ,
  {
    name: "Jarra Pomelada",
    detail: "",
    price: "1200",
    section: "JUGOS & LICUADOS",
  },
  {
    name: "Jugo de naranja ",
    detail: "Exprimido",
    price: "700",
    section: "JUGOS & LICUADOS",
  }
  ,
  {
    name: "Jarra Jugo de naranja ",
    detail: "Exprimido",
    price: "1200",
    section: "JUGOS & LICUADOS",
  }
  ,
  {
    name: "Jugo Detox ",
    detail: "Manzana verde, apio y pepitn",
    price: "800",
    section: "JUGOS & LICUADOS",
  }
  ,
  
  

  {
    name: "Jugo Beta ",
    detail: "Naranja , pomelo, zanahoria, jengibre",
    price: "800",
    section: "JUGOS & LICUADOS",
  },
  {
    name: "Licuado de fruta",
    detail: "",
    price: "700",
    section: "JUGOS & LICUADOS",
  },
  {
    name: "Licuado multifruta",
    detail: "",
    price: "800",
    section: "JUGOS & LICUADOS",
  }
  ,
  {
    name: "MIX CITRICO ",
    detail: "Durazno, frutilla, frutos Rojos",
    price: "800",
    section: "SIN ALCOHOL",
  }
  ,
  {
    name: "JUGO DETOX",
    detail: "Manzana verde, apio, pepino y Kiwi",
    price: "800",
    section: "SIN ALCOHOL",
  }
  ,
  {
    name: "JUGO BETA",
    detail: "Naranja, Pomelo, Zanahoria",
    price: "800",
    section: "SIN ALCOHOL",
  },
  {
    name: "Corona 330",
    detail: "700",
    price: "700",
    section: "CERVEZA",
  },
  {
    name: "Corona 710",
    detail: "",
    price: "1200",
    section: "CERVEZA",
  },
  {
    name: "Stella 330",
    detail: "Lata",
    price: "500",
    section: "CERVEZA",
  },
  {
    name: "Stella 710",
    detail: "",
    price: "1000",
    section: "CERVEZA",
  },
  {
    name: "Lata Patagonia ",
    detail: "",
    price: "700",
    section: "CERVEZA",
  },
  {
    name: "Patagonia 710cc",
    detail: "",
    price: "1200",
    section: "CERVEZA",
  },
  ,
  {
    name: "Malbec Orgánico",
    detail: "Domaine Bousquet",
    price: "2500",
    section: "VINOS & CHAMPAGNE",
  }
  ,
  {
    name: "Sauvignon Blanc Orgánico",
    detail: "Domaine Bousquet",
    price: "2200",
    section: "VINOS & CHAMPAGNE",
  }
  ,
  {
    name: "Rosé Orgánico",
    detail: "Domaine Bousquet",
    price: "2200",
    section: "VINOS & CHAMPAGNE",
  }
  ,
  {
    name: "Extra Brut",
    detail: "Chandon ",
    price: "5200",
    section: "VINOS & CHAMPAGNE",
  }
  ,
  {
    name: "Fernet",
    detail: "",
    price: "1200",
    section: "COCTELERIA CLASSICA",
  },
  {
    name: "Campari",
    detail: "Con Naranja",
    price: "1200",
    section: "COCTELERIA CLASSICA",
  },
  {
    name: "Vodka con jugo ",
    detail: "Con Naranja",
    price: "1400",
    section: "COCTELERIA CLASSICA",
  },
  {
    name: "Vermuth ",
    detail: "",
    price: "1000",
    section: "COCTELERIA CLASSICA",
  },
  {
    name: "WHISKY JOHNNIE WALKER ",
    detail: "ETIQUETA NEGRA",
    price: "2000",
    section: "COCTELERIA CLASSICA",
  },
  {
    name: "Cuba libre",
    detail: "",
    price: "1100",
    section: "COCTELERIA CLASSICA",
  },
  {
    name: "Orange malibu ",
    detail: "",
    price: "1100",
    section: "COCTELERIA ESPECIAL",
  },
  {
    name: "Negroni ",
    detail: "",
    price: "1400",
    section: "COCTELERIA CLASSICA",
  },
  {
    name: "Gin tonic",
    detail: "Bombay",
    price: "1700",
    section: "COCTELERIA ESPECIAL",
  }
  ,
  {
    name: "Gin tonic",
    detail: "Bosque",
    price: "1200",
    section: "COCTELERIA ESPECIAL",
  }
  ,
  {
    name: "Gin tonic Maracuya",
    detail: "",
    price: "1100",
    section: "COCTELERIA ESPECIAL",
  }
  ,
  {
    name: "Gin tonic Frutos rojos",
    detail: "",
    price: "1300",
    section: "COCTELERIA ESPECIAL",
  },
  {
    name: "Jagger julep",
    detail: "",
    price: "1300",
    section: "COCTELERIA ESPECIAL",
  },
  {
    name: "Cynar julep",
    detail: "",
    price: "1400",
    section: "COCTELERIA ESPECIAL",
  },
  {
    name: "Mojito",
    detail: "",
    price: "1100",
    section: "COCTELERIA ESPECIAL",
  },
  {
    name: "Caipirinha ",
    detail: "",
    price: "1300",
    section: "COCTELERIA ESPECIAL",
  },
  {
    name: "Caipiriroska",
    detail: "",
    price: "1400",
    section: "COCTELERIA ESPECIAL",
  },
  {
    name: "Caipirisima",
    detail: "Azúcar rubia, Agua, Menta, Limas, Maracuyá, Hielo, Amor                                            ",
    price: "1400",
    section: "COCTELERIA ESPECIAL",
  },
  {
    name: "Caipi de maracuya ",
    detail: "",
    price: "1400",
    section: "COCTELERIA ESPECIAL",
  },
  {
    name: "Daiquiri",
    detail: "",
    price: "1400",
    section: "COCTELERIA CLASSICA",
  } ,
  {
    name: "Manzanas",
    detail: "Frescas y jugosas",
    price: "1500",
    section: "VERDULERIA"
  },
  {
    name: "Plátanos",
    detail: "Maduros y listos para comer",
    price: "1200",
    section: "VERDULERIA"
  },
  {
    name: "Uvas",
    detail: "Variedad de uvas frescas",
    price: "1800",
    section: "VERDULERIA"
  },
  {
    name: "Zanahorias",
    detail: "Zanahorias orgánicas",
    price: "900",
    section: "VERDULERIA"
  },
  {
    name: "Tomates",
    detail: "Tomates de la mejor calidad",
    price: "1300",
    section: "VERDULERIA"
  },
  {
    name: "Papas",
    detail: "Papas frescas de la temporada",
    price: "1100",
    section: "VERDULERIA"
  },
  {
    name: "Espinacas",
    detail: "Espinacas orgánicas y frescas",
    price: "1600",
    section: "VERDULERIA"
  },
  {
    name: "Fresas",
    detail: "Fresas rojas y dulces",
    price: "2000",
    section: "VERDULERIA"
  },
  {
    name: "Cebollas",
    detail: "Cebollas amarillas y rojas",
    price: "950",
    section: "VERDULERIA"
  },
  {
    name: "Pimientos",
    detail: "Variedad de pimientos frescos",
    price: "1700",
    section: "VERDULERIA"
  },
  {
    name: "Sandías",
    detail: "Sandías jugosas y refrescantes",
    price: "2500",
    section: "VERDULERIA"
  },
  {
    name: "Naranjas",
    detail: "Naranjas de la mejor calidad",
    price: "1200",
    section: "VERDULERIA"
  },
  {
    name: "Limones",
    detail: "Limones frescos para tus recetas",
    price: "1000",
    section: "VERDULERIA"
  },
  {
    name: "Pepinos",
    detail: "Pepinos crujientes y deliciosos",
    price: "1100",
    section: "VERDULERIA"
  },
  {
    name: "Aguacates",
    detail: "Aguacates maduros y listos para comer",
    price: "1800",
    section: "VERDULERIA"
  },
  {
    name: "Piñas",
    detail: "Piñas frescas y jugosas",
    price: "2000",
    section: "VERDULERIA"
  },
  {
    name: "Mangos",
    detail: "Mangos maduros y deliciosos",
    price: "1600",
    section: "VERDULERIA"
  },
  {
    name: "Cilantro",
    detail: "Cilantro fresco para tus platillos",
    price: "800",
    section: "VERDULERIA"
  },
  {
    name: "Ajo",
    detail: "Ajo fresco para realzar tus comidas",
    price: "900",
    section: "VERDULERIA"
  },
  {
    name: "Calabacines",
    detail: "Calabacines tiernos y sabrosos",
    price: "1400",
    section: "VERDULERIA"
  },
  // POLLERIA
  {
    name: "Pechuga de pollo",
    detail: "› Pechuga de pollo fresca",
    price: "2500",
    section: "POLLERIA",
  },
  {
    name: "Alitas de pollo",
    detail: "› Alitas de pollo enteras",
    price: "1800",
    section: "POLLERIA",
  },
  {
    name: "Pollo entero",
    detail: "› Pollo entero sin procesar",
    price: "4000",
    section: "POLLERIA",
  },
  {
    name: "Muslos de pollo",
    detail: "› Muslos de pollo frescos",
    price: "1800",
    section: "POLLERIA",
  },
  {
    name: "Brochetas de pollo",
    detail: "› Brochetas con trozos de pollo crudo",
    price: "3000",
    section: "POLLERIA",
  },
  {
    name: "Picada de pollo",
    detail: "› Picada de pollo para guisos y sopas",
    price: "2000",
    section: "POLLERIA",
  },
  {
    name: "Hígado de pollo",
    detail: "› Hígado fresco de pollo",
    price: "1200",
    section: "POLLERIA",
  },
  {
    name: "Carcasa de pollo",
    detail: "› Carcasa de pollo para caldos",
    price: "1000",
    section: "POLLERIA",
  },
  {
    name: "Corazones de pollo",
    detail: "› Corazones de pollo frescos",
    price: "1500",
    section: "POLLERIA",
  },
  {
    name: "Pollo molida",
    detail: "› Carne de pollo molida",
    price: "2200",
    section: "POLLERIA",
  },

  // CARNICERIA VACUNA
  {
    name: "Bife de chorizo",
    detail: "› Bife de chorizo fresco",
    price: "9000",
    section: "CARNICERIA VACUNA",
  },
  {
    name: "Entrecot",
    detail: "› Entrecot crudo",
    price: "8000",
    section: "CARNICERIA VACUNA",
  },
  {
    name: "Filete mignon",
    detail: "› Filete mignon fresco",
    price: "12000",
    section: "CARNICERIA VACUNA",
  },
  {
    name: "Costillas de res",
    detail: "› Costillas de res crudas",
    price: "6000",
    section: "CARNICERIA VACUNA",
  },
  {
    name: "Carne mechada",
    detail: "› Carne de res para mechado",
    price: "7500",
    section: "CARNICERIA VACUNA",
  },
  {
    name: "Milanesa de carne",
    detail: "› Milanesa de res cruda",
    price: "6500",
    section: "CARNICERIA VACUNA",
  },
  {
    name: "Tiras de carne para stir-fry",
    detail: "› Tiras de carne para salteados",
    price: "7000",
    section: "CARNICERIA VACUNA",
  },
  {
    name: "Estofado de carne",
    detail: "› Trozos de carne para estofado",
    price: "10000",
    section: "CARNICERIA VACUNA",
  },
  {
    name: "Picada de carne",
    detail: "› Picada de carne para guisos",
    price: "8500",
    section: "CARNICERIA VACUNA",
  },
  {
    name: "Carne molida",
    detail: "› Carne de res molida",
    price: "7000",
    section: "CARNICERIA VACUNA",
  },

  // CARNE DE CERDO
  {
    name: "Costillas de cerdo",
    detail: "› Costillas de cerdo frescas",
    price: "7000",
    section: "CARNE DE CERDO",
  },
  {
    name: "Chuletas de cerdo",
    detail: "› Chuletas de cerdo frescas",
    price: "6000",
    section: "CARNE DE CERDO",
  },
  {
    name: "Lomo de cerdo",
    detail: "› Lomo de cerdo fresco",
    price: "8000",
    section: "CARNE DE CERDO",
  },
  {
    name: "Tocino",
    detail: "› Tocino fresco",
    price: "3500",
    section: "CARNE DE CERDO",
  },
  {
    name: "Picada de cerdo",
    detail: "› Picada de cerdo para guisos",
    price: "50000",
    section: "CARNE DE CERDO",
  },
  {
    name: "Mollejas de cerdo",
    detail: "› Mollejas de cerdo frescas",
    price: "30000",
    section: "CARNE DE CERDO",
  },
  {
    name: "Salchichas de cerdo",
    detail: "› Salchichas de cerdo frescas",
    price: "4500",
    section: "CARNE DE CERDO",
  },
  {
    name: "Panceta",
    detail: "› Panceta fresca",
    price: "50000",
    section: "CARNE DE CERDO",
  },
  {
    name: "Pernil de cerdo",
    detail: "› Pernil de cerdo fresco",
    price: "90000",
    section: "CARNE DE CERDO",
  },
  {
    name: "Carne molida de cerdo",
    detail: "› Carne de cerdo molida",
    price: "5500",
    section: "CARNE DE CERDO",
  },

  // PESCADERIA
  {
    name: "Filete de salmón",
    detail: "› Filete fresco de salmón",
    price: "12000",
    section: "PESCADERIA",
  },
  {
    name: "Langostinos",
    detail: "› Langostinos frescos",
    price: "15000",
    section: "PESCADERIA",
  },
  {
    name: "Calamares",
    detail: "› Calamares frescos",
    price: "8000",
    section: "PESCADERIA",
  },
  {
    name: "Atún fresco",
    detail: "› Atún fresco para preparar sushi",
    price: "10000",
    section: "PESCADERIA",
  },
  {
    name: "Pulpo",
    detail: "› Pulpo fresco para ensaladas",
    price: "12000",
    section: "PESCADERIA",
  },
  {
    name: "Filete de merluza",
    detail: "› Filete fresco de merluza",
    price: "7000",
    section: "PESCADERIA",
  },
  {
    name: "Gambas",
    detail: "› Gambas frescas para paella",
    price: "13000",
    section: "PESCADERIA",
  },
  {
    name: "Sardinas",
    detail: "› Sardinas frescas para grillar",
    price: "5000",
    section: "PESCADERIA",
  },
  {
    name: "Almejas",
    detail: "› Almejas frescas para sopas y guisos",
    price: "9000",
    section: "PESCADERIA",
  },
  {
    name: "Trucha arcoíris",
    detail: "› Trucha arcoíris fresca",
    price: "10000",
    section: "PESCADERIA",
  },
   // SECCIÓN DE PASTAS TRADICIONALES
   {
    name: "Fideos de Huevo",
    detail: "› Fideos tradicionales con huevo, ideales para sopas",
    price: "50",
    section: "PASTAS TRADICIONALES",
  },
  {
    name: "Ñoquis",
    detail: "› Ñoquis de papa, suaves y deliciosos",
    price: "60",
    section: "PASTAS TRADICIONALES",
  },
  {
    name: "Lasaña",
    detail: "› Lasaña clásica con capas de pasta, carne y queso",
    price: "80",
    section: "PASTAS TRADICIONALES",
  },
  {
    name: "Tortellini de Queso",
    detail: "› Tortellini relleno de queso ricotta y espinacas",
    price: "70",
    section: "PASTAS TRADICIONALES",
  },
  {
    name: "Ravioli de Carne",
    detail: "› Ravioli relleno de carne de res sazonada",
    price: "75",
    section: "PASTAS TRADICIONALES",
  },
  {
    name: "Pappardelle",
    detail: "› Cintas anchas de pasta, perfectas para salsas sustanciosas",
    price: "65",
    section: "PASTAS TRADICIONALES",
  },
  {
    name: "Tallarines",
    detail: "› Tallarines clásicos, versátiles para diferentes salsas",
    price: "55",
    section: "PASTAS TRADICIONALES",
  },
  {
    name: "Conchiglie",
    detail: "› Conchas pequeñas de pasta, ideales para ensaladas",
    price: "45",
    section: "PASTAS TRADICIONALES",
  },
  {
    name: "Farfalle",
    detail: "› Pasta en forma de mariposa, perfecta para platos fríos",
    price: "60",
    section: "PASTAS TRADICIONALES",
  },
  {
    name: "Fusilli",
    detail: "› Pasta en espiral, captura bien las salsas",
    price: "55",
    section: "PASTAS TRADICIONALES",
  },

  // SECCIÓN DE PASTAS FRESCAS
  {
    name: "Pasta Fresca de Huevo",
    detail: "› Pasta fresca elaborada con huevos, suave y deliciosa",
    price: "900",
    section: "PASTAS FRESCAS",
  },
  {
    name: "Tortelloni de Espinacas",
    detail: "› Grandes tortelloni rellenos de espinacas y queso ricotta",
    price: "1000",
    section: "PASTAS FRESCAS",
  },
  {
    name: "Gnocchi Fresco",
    detail: "› Ñoquis frescos de papa, listos para cocinar",
    price: "750",
    section: "PASTAS FRESCAS",
  },
  {
    name: "Fettuccine Fresco",
    detail: "› Fettuccine fresco, perfecto con salsas cremosas",
    price: "1100",
    section: "PASTAS FRESCAS",
  },
  {
    name: "Lasagna Fresca",
    detail: "› Láminas de lasaña fresca para preparar en casa",
    price: "1200",
    section: "PASTAS FRESCAS",
  },
  {
    name: "Pasta Negra Fresca",
    detail: "› Pasta fresca con tinta de calamar, sorprendente y sabrosa",
    price: "1300",
    section: "PASTAS FRESCAS",
  },
  {
    name: "Ravioli de Ricotta y Espinacas Fresco",
    detail: "› Ravioli fresco relleno de ricotta y espinacas",
    price: "950",
    section: "PASTAS FRESCAS",
  },
  {
    name: "Pasta de Trigo Integral Fresca",
    detail: "› Pasta fresca elaborada con harina de trigo integral",
    price: "850",
    section: "PASTAS FRESCAS",
  },
  {
    name: "Tortellini de Queso Fresco",
    detail: "› Tortellini fresco relleno de queso cremoso",
    price: "1000",
    section: "PASTAS FRESCAS",
  },
  {
    name: "Pappardelle Fresco",
    detail: "› Cintas anchas de pasta fresca, ideal para salsas ricas",
    price: "1050",
    section: "PASTAS FRESCAS",
  },

  // SECCIÓN DE PASTAS ITALIANAS
  {
    name: "Pasta Orecchiette",
    detail: "› Pasta en forma de oreja, típica de la región de Apulia",
    price: "550",
    section: "PASTAS ITALIANAS",
  },
  {
    name: "Trofie",
    detail: "› Pasta en forma de espiral, popular en Liguria",
    price: "500",
    section: "PASTAS ITALIANAS",
  },
  {
    name: "Cavatelli",
    detail: "› Pasta en forma de concha, originaria del sur de Italia",
    price: "650",
    section: "PASTAS ITALIANAS",
  },
  {
    name: "Pasta Garganelli",
    detail: "› Pasta enrollada similar a un tubo, común en Emilia-Romaña",
    price: "700",
    section: "PASTAS ITALIANAS",
  },
  {
    name: "Pasta Pici",
    detail: "› Pasta gruesa y alargada, tradicional de la Toscana",
    price: "750",
    section: "PASTAS ITALIANAS",
  },
  {
    name: "Strozzapreti",
    detail: "› Pasta enrollada a mano, su nombre significa 'estrangula cura'",
    price: "800",
    section: "PASTAS ITALIANAS",
  },
  {
    name: "Trenette",
    detail: "› Pasta plana y delgada, popular en la región de Liguria",
    price: "600",
    section: "PASTAS ITALIANAS",
  },

];
